import { useEffect } from 'react'

export const usePageTheme = () => {
	useEffect(() => {}, [])

	const setDarkTheme = (dark: Boolean) => {
		// change body theme
		let body = document.body

		if (dark) {
			body.classList.add('body-dark')
			body.classList.remove('body-light')
		} else {
			body.classList.remove('body-dark')
			body.classList.add('body-light')
		}

		dark ? body.classList.add('body-dark') : body.classList.add('body-light')

		// change nav theme
		let navIcon = document.querySelectorAll('.nav-icon > span')

		if (dark) {
			navIcon.forEach((e) => e.classList.add('icon-white'))
			navIcon.forEach((e) => e.classList.remove('icon-black'))
		} else {
			navIcon.forEach((e) => e.classList.remove('icon-white'))
			navIcon.forEach((e) => e.classList.add('icon-black'))
		}

		// change footer theme
		let footerBuiltWith = document.querySelector('.footer > p') as HTMLParagraphElement

		dark ? footerBuiltWith.classList.add('built-white') : footerBuiltWith.classList.remove('built-black')
	}

	return { setDarkTheme }
}
